import type { ButtonHTMLAttributes, ReactNode } from 'react'
import { cn } from '@/utils/cn'
import { iconButtonClass } from './pageToolbarStyles'

interface ToolbarIconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  active?: boolean
  children: ReactNode
}

/** Botão quadrado 36×36 — ex.: mostrar/ocultar metas */
export function ToolbarIconButton({
  active = false,
  className,
  children,
  type = 'button',
  ...props
}: ToolbarIconButtonProps) {
  return (
    <button type={type} className={cn(iconButtonClass(active), className)} {...props}>
      {children}
    </button>
  )
}
